import styled from 'styled-components'

export const Root = styled.main`
  min-height: 100vh;
  color: #e5e5e5;
  background-color: #0e0e0e;
  font-family: var(--font-nhu);
  font-weight: 200;
  font-size: 1.125rem;
  line-height: 1.75rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`
